import { render, staticRenderFns } from "./penaltyDetail.vue?vue&type=template&id=2b117ba4&scoped=true"
import script from "./penaltyDetail.vue?vue&type=script&lang=js"
export * from "./penaltyDetail.vue?vue&type=script&lang=js"
import style0 from "./penaltyDetail.vue?vue&type=style&index=0&id=2b117ba4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b117ba4",
  null
  
)

export default component.exports